/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { AddPatientDTO } from '../models';
import { AtlasHistoryDto } from '../models';
import { ExplorerHistoryDto } from '../models';
import { PatientDto } from '../models';
import { PatientHistoryDto } from '../models';
import { PatientView } from '../models';
import { UpdateBlockedStatusDto } from '../models';
import { UpdatePatientDto } from '../models';
/**
 * PatientsApi - axios parameter creator
 * @export
 */
export const PatientsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Add a patient to an organization
     * @param {AddPatientDTO} body Emails of the legal guardian of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerAddPatientToOrganization: async (
      body: AddPatientDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling patientControllerAddPatientToOrganization.'
        );
      }
      const localVarPath = `/patient/organizations/add-patient`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates whether the patient is blocked or not based on the provided status.
     * @summary Update the block status of a patient
     * @param {UpdateBlockedStatusDto} body Patient blocked status
     * @param {string} id Unique identifier for the patient whose block status is to be updated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerChangeBlockedStatus: async (
      body: UpdateBlockedStatusDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling patientControllerChangeBlockedStatus.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerChangeBlockedStatus.'
        );
      }
      const localVarPath = `/patient/{id}/block-status`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new patient
     * @param {PatientDto} body Patient data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerCreate: async (
      body: PatientDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling patientControllerCreate.'
        );
      }
      const localVarPath = `/patient`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all patients paginated
     * @param {string} [page] Page number
     * @param {string} [limit] Number of items per page
     * @param {string} [search] The search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerFindAll: async (
      page?: string,
      limit?: string,
      search?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/patient`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get patient data
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerFindOne: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerFindOne.'
        );
      }
      const localVarPath = `/patient/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Atlas configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGetAtlasHistory: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerGetAtlasHistory.'
        );
      }
      const localVarPath = `/patient/{id}/history/atlas`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all the configuration of the patients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGetConfig: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/patient/config`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get total patients count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGetCount: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/patient/count`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Explorer configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGetExplorerHistory: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerGetExplorerHistory.'
        );
      }
      const localVarPath = `/patient/{id}/history/explorer`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get patient clinical history
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGetPatientClinicalHistory: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerGetPatientClinicalHistory.'
        );
      }
      const localVarPath = `/patient/{id}/history/clinical`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerRemove: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerRemove.'
        );
      }
      const localVarPath = `/patient/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Remove a patient from an organization
     * @param {string} p_id Patient ID
     * @param {string} o_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerRemovePatientFromOrganization: async (
      p_id: string,
      o_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'p_id' is not null or undefined
      if (p_id === null || p_id === undefined) {
        throw new RequiredError(
          'p_id',
          'Required parameter p_id was null or undefined when calling patientControllerRemovePatientFromOrganization.'
        );
      }
      // verify required parameter 'o_id' is not null or undefined
      if (o_id === null || o_id === undefined) {
        throw new RequiredError(
          'o_id',
          'Required parameter o_id was null or undefined when calling patientControllerRemovePatientFromOrganization.'
        );
      }
      const localVarPath = `/patient/patient/{p_id}/organizations/{o_id}`
        .replace(`{${'p_id'}}`, encodeURIComponent(String(p_id)))
        .replace(`{${'o_id'}}`, encodeURIComponent(String(o_id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update patient
     * @param {UpdatePatientDto} body Patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerUpdate: async (
      body: UpdatePatientDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling patientControllerUpdate.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling patientControllerUpdate.'
        );
      }
      const localVarPath = `/patient/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PatientsApi - functional programming interface
 * @export
 */
export const PatientsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add a patient to an organization
     * @param {AddPatientDTO} body Emails of the legal guardian of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerAddPatientToOrganization(
      body: AddPatientDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerAddPatientToOrganization(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Updates whether the patient is blocked or not based on the provided status.
     * @summary Update the block status of a patient
     * @param {UpdateBlockedStatusDto} body Patient blocked status
     * @param {string} id Unique identifier for the patient whose block status is to be updated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerChangeBlockedStatus(
      body: UpdateBlockedStatusDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerChangeBlockedStatus(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create a new patient
     * @param {PatientDto} body Patient data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerCreate(
      body: PatientDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<PatientDto>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerCreate(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary List all patients paginated
     * @param {string} [page] Page number
     * @param {string} [limit] Number of items per page
     * @param {string} [search] The search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerFindAll(
      page?: string,
      limit?: string,
      search?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerFindAll(page, limit, search, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get patient data
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerFindOne(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<PatientView>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerFindOne(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get Atlas configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetAtlasHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<AtlasHistoryDto>>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerGetAtlasHistory(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary List all the configuration of the patients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetConfig(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<PatientDto>>>
    > {
      const localVarAxiosArgs =
        await PatientsApiAxiosParamCreator(
          configuration
        ).patientControllerGetConfig(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get total patients count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetCount(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<number>>
    > {
      const localVarAxiosArgs =
        await PatientsApiAxiosParamCreator(
          configuration
        ).patientControllerGetCount(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get Explorer configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetExplorerHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<ExplorerHistoryDto>>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerGetExplorerHistory(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get patient clinical history
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetPatientClinicalHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<PatientHistoryDto>>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerGetPatientClinicalHistory(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete a patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerRemove(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<PatientDto>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerRemove(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Remove a patient from an organization
     * @param {string} p_id Patient ID
     * @param {string} o_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerRemovePatientFromOrganization(
      p_id: string,
      o_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<boolean>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerRemovePatientFromOrganization(p_id, o_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update patient
     * @param {UpdatePatientDto} body Patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerUpdate(
      body: UpdatePatientDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<UpdatePatientDto>>
    > {
      const localVarAxiosArgs = await PatientsApiAxiosParamCreator(
        configuration
      ).patientControllerUpdate(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PatientsApi - factory interface
 * @export
 */
export const PatientsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Add a patient to an organization
     * @param {AddPatientDTO} body Emails of the legal guardian of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerAddPatientToOrganization(
      body: AddPatientDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return PatientsApiFp(configuration)
        .patientControllerAddPatientToOrganization(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates whether the patient is blocked or not based on the provided status.
     * @summary Update the block status of a patient
     * @param {UpdateBlockedStatusDto} body Patient blocked status
     * @param {string} id Unique identifier for the patient whose block status is to be updated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerChangeBlockedStatus(
      body: UpdateBlockedStatusDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return PatientsApiFp(configuration)
        .patientControllerChangeBlockedStatus(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new patient
     * @param {PatientDto} body Patient data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerCreate(
      body: PatientDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<PatientDto>> {
      return PatientsApiFp(configuration)
        .patientControllerCreate(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List all patients paginated
     * @param {string} [page] Page number
     * @param {string} [limit] Number of items per page
     * @param {string} [search] The search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerFindAll(
      page?: string,
      limit?: string,
      search?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return PatientsApiFp(configuration)
        .patientControllerFindAll(page, limit, search, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get patient data
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerFindOne(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<PatientView>> {
      return PatientsApiFp(configuration)
        .patientControllerFindOne(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Atlas configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetAtlasHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<AtlasHistoryDto>>> {
      return PatientsApiFp(configuration)
        .patientControllerGetAtlasHistory(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List all the configuration of the patients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetConfig(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<PatientDto>>> {
      return PatientsApiFp(configuration)
        .patientControllerGetConfig(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get total patients count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetCount(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<number>> {
      return PatientsApiFp(configuration)
        .patientControllerGetCount(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Explorer configuration history for a patient
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetExplorerHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<ExplorerHistoryDto>>> {
      return PatientsApiFp(configuration)
        .patientControllerGetExplorerHistory(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get patient clinical history
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGetPatientClinicalHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<PatientHistoryDto>>> {
      return PatientsApiFp(configuration)
        .patientControllerGetPatientClinicalHistory(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerRemove(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<PatientDto>> {
      return PatientsApiFp(configuration)
        .patientControllerRemove(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Remove a patient from an organization
     * @param {string} p_id Patient ID
     * @param {string} o_id Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerRemovePatientFromOrganization(
      p_id: string,
      o_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<boolean>> {
      return PatientsApiFp(configuration)
        .patientControllerRemovePatientFromOrganization(p_id, o_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update patient
     * @param {UpdatePatientDto} body Patient
     * @param {string} id Unique patient identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerUpdate(
      body: UpdatePatientDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<UpdatePatientDto>> {
      return PatientsApiFp(configuration)
        .patientControllerUpdate(body, id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
export class PatientsApi extends BaseAPI {
  /**
   *
   * @summary Add a patient to an organization
   * @param {AddPatientDTO} body Emails of the legal guardian of the patient
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerAddPatientToOrganization(
    body: AddPatientDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return PatientsApiFp(this.configuration)
      .patientControllerAddPatientToOrganization(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Updates whether the patient is blocked or not based on the provided status.
   * @summary Update the block status of a patient
   * @param {UpdateBlockedStatusDto} body Patient blocked status
   * @param {string} id Unique identifier for the patient whose block status is to be updated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerChangeBlockedStatus(
    body: UpdateBlockedStatusDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return PatientsApiFp(this.configuration)
      .patientControllerChangeBlockedStatus(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Create a new patient
   * @param {PatientDto} body Patient data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerCreate(
    body: PatientDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<PatientDto>> {
    return PatientsApiFp(this.configuration)
      .patientControllerCreate(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary List all patients paginated
   * @param {string} [page] Page number
   * @param {string} [limit] Number of items per page
   * @param {string} [search] The search term
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerFindAll(
    page?: string,
    limit?: string,
    search?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return PatientsApiFp(this.configuration)
      .patientControllerFindAll(page, limit, search, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get patient data
   * @param {string} id Unique patient identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerFindOne(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<PatientView>> {
    return PatientsApiFp(this.configuration)
      .patientControllerFindOne(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get Atlas configuration history for a patient
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerGetAtlasHistory(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<AtlasHistoryDto>>> {
    return PatientsApiFp(this.configuration)
      .patientControllerGetAtlasHistory(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary List all the configuration of the patients
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerGetConfig(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<PatientDto>>> {
    return PatientsApiFp(this.configuration)
      .patientControllerGetConfig(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get total patients count
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerGetCount(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<number>> {
    return PatientsApiFp(this.configuration)
      .patientControllerGetCount(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get Explorer configuration history for a patient
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerGetExplorerHistory(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<ExplorerHistoryDto>>> {
    return PatientsApiFp(this.configuration)
      .patientControllerGetExplorerHistory(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get patient clinical history
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerGetPatientClinicalHistory(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<PatientHistoryDto>>> {
    return PatientsApiFp(this.configuration)
      .patientControllerGetPatientClinicalHistory(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete a patient
   * @param {string} id Unique patient identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerRemove(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<PatientDto>> {
    return PatientsApiFp(this.configuration)
      .patientControllerRemove(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Remove a patient from an organization
   * @param {string} p_id Patient ID
   * @param {string} o_id Organization ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerRemovePatientFromOrganization(
    p_id: string,
    o_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<boolean>> {
    return PatientsApiFp(this.configuration)
      .patientControllerRemovePatientFromOrganization(p_id, o_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update patient
   * @param {UpdatePatientDto} body Patient
   * @param {string} id Unique patient identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientsApi
   */
  public async patientControllerUpdate(
    body: UpdatePatientDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<UpdatePatientDto>> {
    return PatientsApiFp(this.configuration)
      .patientControllerUpdate(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
